import { render, staticRenderFns } from "./FormInputHorizontalLableSize.vue?vue&type=template&id=07368412&"
import script from "./FormInputHorizontalLableSize.vue?vue&type=script&lang=js&"
export * from "./FormInputHorizontalLableSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports